import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useSummaryStore = create(
  persist(
    (set) => ({
      // 国家选择
      country: 'BR',
      updateCountry: (value) =>
        set({ country: value === 'all' ? 'BR' : value }),

      // PID选择
      pid: '1',
      updatePid: (value) => set({ pid: value }),
    }),
    {
      name: 'summary-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
